import { actions } from './actions'

const initialState = {
  categoriasHomeByCategoria: {
    data: [],
    loading: false,
    error: '',
  },
  categoriasHomeByEtiqueta: {
    data: [],
    loading: false,
    error: '',
  },
  categoriasHomeByFecha: {
    data: [],
    loading: false,
    error: '',
  },
  categoriasHome: {
    data: [],
    loading: false,
    error: '',
  },
  categoriasHomeSelected: {
    data: [],
    loading: false,
    error: '',
  },
  categoriasEspecialSelected: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function categoriasHomeReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CATEGORIA_HOME_ALL_LOAD_REQUESTED:
      return {
        ...state,
        categoriasHome: { ...state.categoriasHome, loading: true },
      }
    case actions.CATEGORIA_HOME_ALL_LOAD_SUCCEEDED:
      return {
        ...state,
        categoriasHome: {
          ...state.categoriasHome,
          data: action.payload,
          loading: false,
        },
      }
    case actions.CATEGORIA_HOME_ALL_LOAD_FILED:
      return {
        ...state,
        categoriasHome: {
          ...state.categoriasHome,
          loading: false,
          error: action.error,
        },
      }
    case actions.CATEGORIA_HOME_SELECTED_LOAD_REQUESTED:
      return {
        ...state,
        categoriasHomeSelected: { ...state.categoriasHomeSelected, loading: true },
      }
    case actions.CATEGORIA_HOME_SELECTED_LOAD_SUCCEEDED:
      return {
        ...state,
        categoriasHomeSelected: {
          ...state.categoriasHomeSelected,
          data: action.payload,
          loading: false,
        },
      }
    case actions.CATEGORIA_HOME_SELECTED_LOAD_FILED:
      return {
        ...state,
        categoriasHomeSelected: {
          ...state.categoriasHomeSelected,
          loading: false,
          error: action.error,
        },
      }
    case actions.CATEGORIA_ESPECIAL_SELECTED_LOAD_REQUESTED:
      return {
        ...state,
        categoriasEspecialSelected: { ...state.categoriasEspecialSelected, loading: true },
      }
    case actions.CATEGORIA_ESPECIAL_SELECTED_LOAD_SUCCEEDED:
      return {
        ...state,
        categoriasEspecialSelected: {
          ...state.categoriasEspecialSelected,
          data: action.payload,
          loading: false,
        },
      }
    case actions.CATEGORIA_ESPECIAL_SELECTED_LOAD_FILED:
      return {
        ...state,
        categoriasEspecialSelected: {
          ...state.categoriasEspecialSelected,
          loading: false,
          error: action.error,
        },
      }
    case actions.CATEGORIA_HOME_BY_CATEGORIA_ID_LOAD_REQUESTED:
      return {
        ...state,
        categoriasHomeByCategoria: { ...state.categoriasHomeByCategoria, loading: true },
      }
    case actions.CATEGORIA_HOME_BY_CATEGORIA_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        categoriasHomeByCategoria: {
          ...state.categoriasHomeByCategoria,
          data: action.payload,
          loading: false,
        },
      }
    case actions.CATEGORIA_HOME_BY_CATEGORIA_ID_LOAD_FILED:
      return {
        ...state,
        categoriasHomeByCategoria: {
          ...state.categoriasHomeByCategoria,
          loading: false,
          error: action.error,
        },
      }
    case actions.CATEGORIA_HOME_BY_ETIQUETA_ID_LOAD_REQUESTED:
      return {
        ...state,
        categoriasHomeByEtiqueta: { ...state.categoriasHomeByEtiqueta, loading: true },
      }
    case actions.CATEGORIA_HOME_BY_ETIQUETA_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        categoriasHomeByEtiqueta: {
          ...state.categoriasHomeByEtiqueta,
          data: action.payload,
          loading: false,
        },
      }
    case actions.CATEGORIA_HOME_BY_ETIQUETA_ID_LOAD_FILED:
      return {
        ...state,
        categoriasHomeByEtiqueta: {
          ...state.categoriasHomeByEtiqueta,
          loading: false,
          error: action.error,
        },
      }
    case actions.CATEGORIA_HOME_BY_FECHA_ID_LOAD_REQUESTED:
      return { ...state, categoriasHomeByFecha: { ...state.categoriasHomeByFecha, loading: true } }
    case actions.CATEGORIA_HOME_BY_FECHA_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        categoriasHomeByFecha: {
          ...state.categoriasHomeByFecha,
          data: action.payload,
          loading: false,
        },
      }
    case actions.CATEGORIA_HOME_BY_FECHA_ID_LOAD_FILED:
      return {
        ...state,
        categoriasHomeByFecha: {
          ...state.categoriasHomeByFecha,
          loading: false,
          error: action.error,
        },
      }
    case actions.CATEGORIA_HOME_UPDATE_REQUESTED:
      return {
        ...state,
        categoriasHomeByCategoria: { ...state.categoriasHomeByCategoria, loading: true },
        categoriasHomeByEtiqueta: { ...state.categoriasHomeByEtiqueta, loading: true },
        categoriasHomeByFecha: { ...state.categoriasHomeByFecha, loading: true },
      }
    case actions.CATEGORIA_HOME_UPDATE_SUCCEEDED:
      return {
        ...state,
        categoriasHomeByCategoria: { ...state.categoriasHomeByCategoria, loading: false },
        categoriasHomeByEtiqueta: { ...state.categoriasHomeByCategoria, loading: false },
        categoriasHomeByFecha: { ...state.categoriasHomeByFecha, loading: false },
      }
    case actions.CATEGORIA_HOME_UPDATE_FILED:
      return {
        ...state,
        categoriasHomeByCategoria: {
          ...state.categoriasHomeByCategoria,
          loading: false,
          error: action.error,
        },
        categoriasHomeByEtiqueta: {
          ...state.categoriasHomeByCategoria,
          loading: false,
          error: action.error,
        },
        categoriasHomeByFecha: {
          ...state.categoriasHomeByFecha,
          loading: false,
          error: action.error,
        },
      }
    case actions.CATEGORIA_HOME_UPDATE_SELECTED_REQUESTED:
      return {
        ...state,
        categoriasHomeSelected: { ...state.categoriasHomeSelected, loading: true },
      }
    case actions.CATEGORIA_HOME_UPDATE_SELECTED_SUCCEEDED:
      return {
        ...state,
        categoriasHomeSelected: {
          ...state.categoriasHomeSelected,
          data: action.payload,
          loading: false,
        },
      }
    case actions.CATEGORIA_HOME_UPDATE_SELECTED_FILED:
      return {
        ...state,
        categoriasHomeSelected: {
          ...state.categoriasHomeSelected,
          loading: false,
          error: action.error,
        },
      }
    case actions.CATEGORIA_ESPECIAL_UPDATE_SELECTED_REQUESTED:
      return {
        ...state,
        categoriasEspecialSelected: { ...state.categoriasEspecialSelected, loading: true },
      }
    case actions.CATEGORIA_ESPECIAL_UPDATE_SELECTED_SUCCEEDED:
      return {
        ...state,
        categoriasEspecialSelected: {
          ...state.categoriasEspecialSelected,
          data: action.payload,
          loading: false,
        },
      }
    case actions.CATEGORIA_ESPECIAL_UPDATE_SELECTED_FAILED:
      return {
        ...state,
        categoriasEspecialSelected: {
          ...state.categoriasEspecialSelected,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
